import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <header className="header">
      <nav className="nav-links">
        <a href="https://www.etsy.com/shop/ThePineWoodsStore" target="_blank" rel="noopener noreferrer">Shop</a>
        <Link to="/#collections">Collections</Link>
        <Link to="/events">Events</Link>
        <Link to="/#about">About</Link>
      </nav>
      <div className="logo-container">
        <Link to="/" className="logo-link"><h2>The Pine Woods</h2></Link>
      </div>
      <a
        href="https://www.instagram.com/from_thepinewoods/"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-button"
      >
        Contact Me
      </a>
    </header>
  );
}

export default Navbar;
